module.exports = __webpack_public_path__ + "img/background-bottom.a647eada.jpg";